import { urlSeccion as urlSeccionFn } from 'src/app/shared/secciones';
import {
  Component,
  Input,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { GooglesheetService } from 'src/app/services/googlesheet.service';
import { MensajeWhatsappService } from 'src/app/services/mensaje-whatsapp.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeaderComponent {
  urlSeccion = urlSeccionFn;

  @Input() sidenav!: MatSidenav;
  @Input() dolarBlueFormateado: string = '';

  hojas: any[] = [];
  logo: string = '';
  logoError: boolean = false;

  constructor(
    private sheetService: GooglesheetService,
    private mensajeWhatsappService: MensajeWhatsappService,
  ) {}

  ngOnInit() {
    this.obtenerHojas();
    this.obtenerLogo();
  }

  obtenerHojas() {
    this.sheetService.hojas$.subscribe((data) => {
      this.hojas = data;
    });
  }

  obtenerLogo() {
    this.sheetService.getSheetData('Imagenes!B1:B1', 'config').subscribe({
      next: (logo) => {
        this.logo = logo.values[0];
      },
      error: (error) => {
        console.error('No se pudo cargar el logo', error);
        this.logoError = true;
      },
    });
  }

  enviarWhatsApp() {
    this.mensajeWhatsappService.enviarWhatsApp();
  }
}
